// Tennessee county divorce filing information
// Court type: which court handles divorce in each county
// Judicial district reference
// Clerk contact info sourced from tncourts.gov — customers directed to official site for current fees

export const COUNTIES = [
  {
    name: 'Anderson',
    court: 'Circuit',
    district: '7th',
    city: 'Clinton',
    courthouse: 'Anderson County Courthouse, 100 N. Main Street, Clinton, TN 37716',
    phone: '865-457-6235',
    website: 'https://www.andersontn.org/circuit-court',
    notes: 'Divorce cases heard in Circuit Court.',
  },
  {
    name: 'Bedford',
    court: 'Circuit & Chancery',
    district: '17th',
    city: 'Shelbyville',
    courthouse: 'Bedford County Courthouse, 1 Public Square, Shelbyville, TN 37160',
    phone: '931-684-1921',
    website: 'https://www.bedfordcountytn.gov',
    notes: 'Divorce cases may be filed in either Circuit or Chancery Court.',
  },
  {
    name: 'Blount',
    court: 'Circuit & Chancery',
    district: '5th',
    city: 'Maryville',
    courthouse: 'Blount County Courthouse, 345 Court Street, Maryville, TN 37804',
    phone: '865-273-5400',
    website: 'https://www.blounttn.org',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Bradley',
    court: 'Circuit & Chancery',
    district: '10th',
    city: 'Cleveland',
    courthouse: 'Bradley County Courthouse, 155 Broad Street NW, Cleveland, TN 37311',
    phone: '423-728-7185',
    website: 'https://www.bradleycountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Campbell',
    court: 'Circuit & Chancery',
    district: '8th',
    city: 'Jacksboro',
    courthouse: 'Campbell County Courthouse, 570 Main Street, Jacksboro, TN 37757',
    phone: '423-562-3496',
    website: 'https://www.campbellcountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Carter',
    court: 'Circuit & Chancery',
    district: '1st',
    city: 'Elizabethton',
    courthouse: 'Carter County Courthouse, 801 East Elk Avenue, Elizabethton, TN 37643',
    phone: '423-542-1814',
    website: 'https://www.cartercountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Cheatham',
    court: 'Circuit & Chancery',
    district: '23rd',
    city: 'Ashland City',
    courthouse: 'Cheatham County Courthouse, 100 Public Square, Ashland City, TN 37015',
    phone: '615-792-4316',
    website: 'https://www.cheathamcounty.net',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Chester',
    court: 'Circuit & Chancery',
    district: '26th',
    city: 'Henderson',
    courthouse: 'Chester County Courthouse, 133 E. Main Street, Henderson, TN 38340',
    phone: '731-989-2233',
    website: 'https://www.chestercountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Claiborne',
    court: 'Circuit & Chancery',
    district: '8th',
    city: 'Tazewell',
    courthouse: 'Claiborne County Courthouse, 415 Main Street, Tazewell, TN 37879',
    phone: '423-626-3284',
    website: 'https://www.claibornecountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Coffee',
    court: 'Circuit & Chancery',
    district: '14th',
    city: 'Manchester',
    courthouse: 'Coffee County Courthouse, 300 Hillsboro Blvd., Manchester, TN 37355',
    phone: '931-723-5106',
    website: 'https://www.coffeecountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Davidson',
    court: 'Circuit & Chancery',
    district: '20th',
    city: 'Nashville',
    courthouse: 'Justice A.A. Birch Building, 408 2nd Avenue North, Nashville, TN 37201',
    phone: '615-862-5181',
    website: 'https://circuitclerk.nashville.gov',
    notes: 'Nashville/Davidson County: divorce filed in Circuit Court (3rd or 4th Circuit) or Chancery Court. E-filing available in Chancery Court.',
    population: 715884,
  },
  {
    name: 'Dickson',
    court: 'Circuit & Chancery',
    district: '23rd',
    city: 'Charlotte',
    courthouse: 'Dickson County Courthouse, 4 Court Square, Charlotte, TN 37036',
    phone: '615-789-7011',
    website: 'https://www.dicksoncountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Dyer',
    court: 'Circuit & Chancery',
    district: '29th',
    city: 'Dyersburg',
    courthouse: 'Dyer County Courthouse, 101 W. Court Square, Dyersburg, TN 38024',
    phone: '731-286-7814',
    website: 'https://www.dyercountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Fayette',
    court: 'Circuit & Chancery',
    district: '25th',
    city: 'Somerville',
    courthouse: 'Fayette County Courthouse, 16755 Highway 64, Somerville, TN 38068',
    phone: '901-465-5218',
    website: 'https://www.fayettecountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Franklin',
    court: 'Circuit & Chancery',
    district: '17th',
    city: 'Winchester',
    courthouse: 'Franklin County Courthouse, 1 S. Jefferson Street, Winchester, TN 37398',
    phone: '931-967-2906',
    website: 'https://www.franklincountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Gibson',
    court: 'Circuit & Chancery',
    district: '28th',
    city: 'Trenton',
    courthouse: 'Gibson County Courthouse, 1 Court Square, Trenton, TN 38382',
    phone: '731-855-7617',
    website: 'https://www.gibsoncountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Giles',
    court: 'Circuit & Chancery',
    district: '22nd',
    city: 'Pulaski',
    courthouse: 'Giles County Courthouse, 1 Public Square, Pulaski, TN 38478',
    phone: '931-363-1509',
    website: 'https://www.gilescountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Hamilton',
    court: 'Circuit & Chancery',
    district: '11th',
    city: 'Chattanooga',
    courthouse: '625 Georgia Avenue, Chattanooga, TN 37402',
    phone: '423-209-6600',
    website: 'https://www.hamiltontn.gov/Courts.aspx',
    notes: 'Chattanooga/Hamilton County: divorce filed in Circuit Court or Chancery Court. Circuit Court Clerk: 423-209-6600. Clerk and Master (Chancery): 423-209-6600.',
    population: 377323,
  },
  {
    name: 'Hardeman',
    court: 'Circuit & Chancery',
    district: '25th',
    city: 'Bolivar',
    courthouse: 'Hardeman County Courthouse, 100 N. Main Street, Bolivar, TN 38008',
    phone: '731-658-3541',
    website: 'https://www.hardemancountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Hardin',
    court: 'Circuit & Chancery',
    district: '24th',
    city: 'Savannah',
    courthouse: 'Hardin County Courthouse, 601 Main Street, Savannah, TN 38372',
    phone: '731-925-8160',
    website: 'https://www.hardincountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Hawkins',
    court: 'Circuit & Chancery',
    district: '3rd',
    city: 'Rogersville',
    courthouse: 'Hawkins County Courthouse, 100 E. Main Street, Rogersville, TN 37857',
    phone: '423-272-7359',
    website: 'https://www.hawkinscountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Haywood',
    court: 'Circuit & Chancery',
    district: '28th',
    city: 'Brownsville',
    courthouse: 'Haywood County Courthouse, 1 N. Washington Avenue, Brownsville, TN 38012',
    phone: '731-772-1432',
    website: 'https://www.haywoodcountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Henderson',
    court: 'Circuit & Chancery',
    district: '26th',
    city: 'Lexington',
    courthouse: 'Henderson County Courthouse, 17 Monroe Street, Lexington, TN 38351',
    phone: '731-968-2856',
    website: 'https://www.hendersoncountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Henry',
    court: 'Circuit & Chancery',
    district: '24th',
    city: 'Paris',
    courthouse: 'Henry County Courthouse, 101 W. Washington Street, Paris, TN 38242',
    phone: '731-642-2412',
    website: 'https://www.henrycountytn.org',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Hickman',
    court: 'Circuit & Chancery',
    district: '21st',
    city: 'Centerville',
    courthouse: 'Hickman County Courthouse, 110 College Avenue, Centerville, TN 37033',
    phone: '931-729-2241',
    website: 'https://www.hickmancountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Houston',
    court: 'Circuit & Chancery',
    district: '23rd',
    city: 'Erin',
    courthouse: 'Houston County Courthouse, 4956 Main Street, Erin, TN 37061',
    phone: '931-289-3870',
    website: 'https://www.houstoncountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Humphreys',
    court: 'Circuit & Chancery',
    district: '23rd',
    city: 'Waverly',
    courthouse: 'Humphreys County Courthouse, 102 Thompson Street, Waverly, TN 37185',
    phone: '931-296-7671',
    website: 'https://www.humphreyscountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Jackson',
    court: 'Circuit & Chancery',
    district: '13th',
    city: 'Gainesboro',
    courthouse: 'Jackson County Courthouse, 101 E. Hull Avenue, Gainesboro, TN 38562',
    phone: '931-268-9888',
    website: 'https://www.jacksoncountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Jefferson',
    court: 'Circuit & Chancery',
    district: '4th',
    city: 'Dandridge',
    courthouse: 'Jefferson County Courthouse, 202 W. Main Street, Dandridge, TN 37725',
    phone: '865-397-2935',
    website: 'https://www.jeffersoncountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Johnson',
    court: 'Circuit & Chancery',
    district: '1st',
    city: 'Mountain City',
    courthouse: 'Johnson County Courthouse, 222 W. Main Street, Mountain City, TN 37683',
    phone: '423-727-9633',
    website: 'https://www.johnsoncountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Knox',
    court: 'Circuit & Chancery',
    district: '6th',
    city: 'Knoxville',
    courthouse: 'City-County Building, 400 Main Avenue, Knoxville, TN 37902',
    phone: '865-215-2500',
    website: 'https://www.knoxcounty.org/courts',
    notes: 'Knoxville/Knox County: divorce filed in Circuit Court or Chancery Court. Knox County Circuit Court Clerk: 865-215-2500.',
    population: 478971,
  },
  {
    name: 'Lake',
    court: 'Circuit & Chancery',
    district: '29th',
    city: 'Tiptonville',
    courthouse: 'Lake County Courthouse, 229 Church Street, Tiptonville, TN 38079',
    phone: '731-253-7584',
    website: 'https://www.lakecountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Lauderdale',
    court: 'Circuit & Chancery',
    district: '28th',
    city: 'Ripley',
    courthouse: 'Lauderdale County Courthouse, 100 Court Square, Ripley, TN 38063',
    phone: '731-635-2561',
    website: 'https://www.lauderdalecountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Lawrence',
    court: 'Circuit & Chancery',
    district: '22nd',
    city: 'Lawrenceburg',
    courthouse: 'Lawrence County Courthouse, 240 W. Gaines Street, Lawrenceburg, TN 38464',
    phone: '931-762-3241',
    website: 'https://www.lawrencecountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Lewis',
    court: 'Circuit & Chancery',
    district: '22nd',
    city: 'Hohenwald',
    courthouse: 'Lewis County Courthouse, 110 N. Park Street, Hohenwald, TN 38462',
    phone: '931-796-3734',
    website: 'https://www.lewiscountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Lincoln',
    court: 'Circuit & Chancery',
    district: '17th',
    city: 'Fayetteville',
    courthouse: 'Lincoln County Courthouse, 112 Main Avenue South, Fayetteville, TN 37334',
    phone: '931-433-2454',
    website: 'https://www.lincolncountytn.org',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Loudon',
    court: 'Circuit & Chancery',
    district: '9th',
    city: 'Loudon',
    courthouse: 'Loudon County Justice Center, 1095 Highway 72 North, Loudon, TN 37774',
    phone: '865-458-5690',
    website: 'https://www.loudoncounty.org',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'McMinn',
    court: 'Circuit & Chancery',
    district: '10th',
    city: 'Athens',
    courthouse: 'McMinn County Courthouse, 6 E. Madison Avenue, Athens, TN 37303',
    phone: '423-745-4440',
    website: 'https://www.mcminncountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'McNairy',
    court: 'Circuit & Chancery',
    district: '25th',
    city: 'Selmer',
    courthouse: 'McNairy County Courthouse, 300 Cypress Avenue, Selmer, TN 38375',
    phone: '731-645-3511',
    website: 'https://www.mcnairycountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Macon',
    court: 'Circuit & Chancery',
    district: '15th',
    city: 'Lafayette',
    courthouse: 'Macon County Courthouse, 104 County Courthouse Square, Lafayette, TN 37083',
    phone: '615-666-2363',
    website: 'https://www.maconcountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Madison',
    court: 'Circuit & Chancery',
    district: '26th',
    city: 'Jackson',
    courthouse: 'Madison County Courthouse, 100 E. Main Street, Jackson, TN 38301',
    phone: '731-423-6022',
    website: 'https://www.madisoncountytn.gov',
    notes: 'Jackson/Madison County: divorce filed in Circuit or Chancery Court.',
    population: 98294,
  },
  {
    name: 'Marion',
    court: 'Circuit & Chancery',
    district: '12th',
    city: 'Jasper',
    courthouse: 'Marion County Courthouse, 24 Courthouse Square, Jasper, TN 37347',
    phone: '423-942-2515',
    website: 'https://www.marioncountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Marshall',
    court: 'Circuit & Chancery',
    district: '17th',
    city: 'Lewisburg',
    courthouse: 'Marshall County Courthouse, 1 Public Square, Lewisburg, TN 37091',
    phone: '931-359-0017',
    website: 'https://www.marshallcountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Maury',
    court: 'Circuit & Chancery',
    district: '22nd',
    city: 'Columbia',
    courthouse: 'Maury County Courthouse, 41 Public Square, Columbia, TN 38401',
    phone: '931-381-3690',
    website: 'https://www.maurycounty-tn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
    population: 102619,
  },
  {
    name: 'Meigs',
    court: 'Circuit & Chancery',
    district: '10th',
    city: 'Decatur',
    courthouse: 'Meigs County Courthouse, 17214 State Highway 58, Decatur, TN 37322',
    phone: '423-334-5747',
    website: 'https://www.meigscountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Monroe',
    court: 'Circuit & Chancery',
    district: '9th',
    city: 'Madisonville',
    courthouse: 'Monroe County Courthouse, 103 College Street, Madisonville, TN 37354',
    phone: '423-442-2220',
    website: 'https://www.monroecountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Montgomery',
    court: 'Circuit & Chancery',
    district: '19th',
    city: 'Clarksville',
    courthouse: 'Montgomery County Courts Complex, 2 Millennium Plaza, Clarksville, TN 37040',
    phone: '931-648-5703',
    website: 'https://montgomerytn.gov/chancery',
    notes: 'Clarksville/Montgomery County: divorce filed in Circuit or Chancery Court. Chancery Clerk and Master: 931-648-5703.',
    population: 220069,
  },
  {
    name: 'Moore',
    court: 'Circuit & Chancery',
    district: '17th',
    city: 'Lynchburg',
    courthouse: 'Moore County Courthouse, 196 Main Street, Lynchburg, TN 37352',
    phone: '931-759-7346',
    website: 'https://www.moorecountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Morgan',
    court: 'Circuit & Chancery',
    district: '8th',
    city: 'Wartburg',
    courthouse: 'Morgan County Courthouse, 415 N. Kingston Street, Wartburg, TN 37887',
    phone: '423-346-3480',
    website: 'https://www.morgancountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Obion',
    court: 'Circuit & Chancery',
    district: '27th',
    city: 'Union City',
    courthouse: 'Obion County Courthouse, 2 Bill Burnett Circle, Union City, TN 38261',
    phone: '731-885-3831',
    website: 'https://www.obioncountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Overton',
    court: 'Circuit & Chancery',
    district: '13th',
    city: 'Livingston',
    courthouse: 'Overton County Courthouse, 317 W. Main Street, Livingston, TN 38570',
    phone: '931-823-5630',
    website: 'https://www.overtoncountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Perry',
    court: 'Circuit & Chancery',
    district: '21st',
    city: 'Linden',
    courthouse: 'Perry County Courthouse, 121 W. Tennessee Street, Linden, TN 37096',
    phone: '931-589-2216',
    website: 'https://www.perrycountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Pickett',
    court: 'Circuit & Chancery',
    district: '13th',
    city: 'Byrdstown',
    courthouse: 'Pickett County Courthouse, 1 Courthouse Square, Byrdstown, TN 38549',
    phone: '931-864-3798',
    website: 'https://www.pickettcountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Polk',
    court: 'Circuit & Chancery',
    district: '10th',
    city: 'Benton',
    courthouse: 'Polk County Courthouse, 1 Public Square, Benton, TN 37307',
    phone: '423-338-4527',
    website: 'https://www.polkcountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Putnam',
    court: 'Circuit & Chancery',
    district: '13th',
    city: 'Cookeville',
    courthouse: 'Putnam County Courthouse, 421 E. Spring Street, Cookeville, TN 38501',
    phone: '931-526-4137',
    website: 'https://www.putnamcountytn.gov',
    notes: 'Cookeville/Putnam County: divorce filed in Circuit or Chancery Court.',
    population: 80888,
  },
  {
    name: 'Rhea',
    court: 'Circuit & Chancery',
    district: '12th',
    city: 'Dayton',
    courthouse: 'Rhea County Courthouse, 1475 Market Street, Dayton, TN 37321',
    phone: '423-775-7808',
    website: 'https://www.rheacountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Roane',
    court: 'Circuit & Chancery',
    district: '9th',
    city: 'Kingston',
    courthouse: 'Roane County Courthouse, 200 E. Race Street, Kingston, TN 37763',
    phone: '865-376-5556',
    website: 'https://www.roanecountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Robertson',
    court: 'Circuit & Chancery',
    district: '19th',
    city: 'Springfield',
    courthouse: 'Robertson County Courthouse, 501 S. Brown Street, Springfield, TN 37172',
    phone: '615-384-5650',
    website: 'https://www.robertsoncountytn.org',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Rutherford',
    court: 'Circuit & Chancery',
    district: '16th',
    city: 'Murfreesboro',
    courthouse: 'Rutherford County Courthouse, 20 N. Public Square, Murfreesboro, TN 37130',
    phone: '615-898-7820',
    website: 'https://rcchancery.com',
    notes: 'Murfreesboro/Rutherford County: divorce filed in Circuit or Chancery Court. Chancery Clerk and Master also serves as Special Master for divorce matters.',
    population: 341486,
  },
  {
    name: 'Scott',
    court: 'Circuit & Chancery',
    district: '8th',
    city: 'Huntsville',
    courthouse: 'Scott County Courthouse, 280 Court Street, Huntsville, TN 37756',
    phone: '423-663-2694',
    website: 'https://www.scottcountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Sequatchie',
    court: 'Circuit & Chancery',
    district: '12th',
    city: 'Dunlap',
    courthouse: 'Sequatchie County Courthouse, 65 Cherry Street, Dunlap, TN 37327',
    phone: '423-949-2522',
    website: 'https://www.sequatchiecountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Sevier',
    court: 'Circuit & Chancery',
    district: '4th',
    city: 'Sevierville',
    courthouse: 'Sevier County Courthouse, 125 Court Avenue, Sevierville, TN 37862',
    phone: '865-453-4668',
    website: 'https://www.seviercountytn.org',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Shelby',
    court: 'Circuit & Chancery',
    district: '30th',
    city: 'Memphis',
    courthouse: 'Shelby County Courthouse, 140 Adams Avenue, Memphis, TN 38103',
    phone: '901-222-3900',
    website: 'https://www.shelbycountytn.gov/courts',
    notes: 'Memphis/Shelby County: one of Tennessee\'s busiest divorce courts. Filed in Circuit Court (Family Law Division) or Chancery Court. Circuit Court Clerk: 901-222-3900.',
    population: 929744,
  },
  {
    name: 'Smith',
    court: 'Circuit & Chancery',
    district: '15th',
    city: 'Carthage',
    courthouse: 'Smith County Courthouse, 211 N. Main Street, Carthage, TN 37030',
    phone: '615-735-2294',
    website: 'https://www.smithcountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Stewart',
    court: 'Circuit & Chancery',
    district: '23rd',
    city: 'Dover',
    courthouse: 'Stewart County Courthouse, 225 Donelson Pkwy, Dover, TN 37058',
    phone: '931-232-5371',
    website: 'https://www.stewartcountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Sullivan',
    court: 'Circuit & Chancery',
    district: '2nd',
    city: 'Blountville',
    courthouse: 'Sullivan County Justice Center, 3411 Highway 126, Blountville, TN 37617',
    phone: '423-279-2727',
    website: 'https://www.sullivancountytn.gov',
    notes: 'Kingsport/Bristol/Sullivan County: divorce filed in Circuit or Chancery Court.',
    population: 158348,
  },
  {
    name: 'Sumner',
    court: 'Circuit & Chancery',
    district: '18th',
    city: 'Gallatin',
    courthouse: 'Sumner County Courts Building, 100 Public Square, Gallatin, TN 37066',
    phone: '615-452-4063',
    website: 'https://www.sumnercountytn.gov',
    notes: 'Gallatin/Sumner County: divorce filed in Circuit or Chancery Court.',
    population: 196281,
  },
  {
    name: 'Tipton',
    court: 'Circuit & Chancery',
    district: '25th',
    city: 'Covington',
    courthouse: 'Tipton County Courthouse, 1801 S. College Street, Covington, TN 38019',
    phone: '901-476-0207',
    website: 'https://www.tiptoncountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Trousdale',
    court: 'Circuit & Chancery',
    district: '15th',
    city: 'Hartsville',
    courthouse: 'Trousdale County Courthouse, 328 E. Main Street, Hartsville, TN 37074',
    phone: '615-374-2906',
    website: 'https://www.trousdalecountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Unicoi',
    court: 'Circuit & Chancery',
    district: '1st',
    city: 'Erwin',
    courthouse: 'Unicoi County Courthouse, 100 N. Main Avenue, Erwin, TN 37650',
    phone: '423-743-3381',
    website: 'https://www.unicoicountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Union',
    court: 'Circuit & Chancery',
    district: '8th',
    city: 'Maynardville',
    courthouse: 'Union County Courthouse, 901 Main Street, Maynardville, TN 37807',
    phone: '865-992-3061',
    website: 'https://www.unioncountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Van Buren',
    court: 'Circuit & Chancery',
    district: '31st',
    city: 'Spencer',
    courthouse: 'Van Buren County Courthouse, 182 Smithville Highway, Spencer, TN 38585',
    phone: '931-946-2121',
    website: 'https://www.vanburencountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Warren',
    court: 'Circuit & Chancery',
    district: '31st',
    city: 'McMinnville',
    courthouse: 'Warren County Courthouse, 111 S. Court Square, McMinnville, TN 37110',
    phone: '931-473-2269',
    website: 'https://www.warrencountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Washington',
    court: 'Circuit & Chancery',
    district: '1st',
    city: 'Jonesborough',
    courthouse: 'Washington County Courthouse, 100 E. Main Street, Jonesborough, TN 37659',
    phone: '423-753-1613',
    website: 'https://www.washingtoncountytn.org',
    notes: 'Johnson City/Washington County: divorce filed in Circuit or Chancery Court.',
    population: 133001,
  },
  {
    name: 'Wayne',
    court: 'Circuit & Chancery',
    district: '22nd',
    city: 'Waynesboro',
    courthouse: 'Wayne County Courthouse, 103 W. Court Street, Waynesboro, TN 38485',
    phone: '931-722-5544',
    website: 'https://www.waynecountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Weakley',
    court: 'Circuit & Chancery',
    district: '27th',
    city: 'Dresden',
    courthouse: 'Weakley County Courthouse, 116 W. Main Street, Dresden, TN 38225',
    phone: '731-364-2285',
    website: 'https://www.weakleycountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'White',
    court: 'Circuit & Chancery',
    district: '13th',
    city: 'Sparta',
    courthouse: 'White County Courthouse, 1 East Bockman Way, Sparta, TN 38583',
    phone: '931-836-3706',
    website: 'https://www.whitecountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Williamson',
    court: 'Circuit & Chancery',
    district: '21st',
    city: 'Franklin',
    courthouse: 'Williamson County Administrative Complex, 1320 W. Main Street, Franklin, TN 37064',
    phone: '615-790-5428',
    website: 'https://www.williamsoncounty-tn.gov',
    notes: 'Franklin/Williamson County: one of Tennessee\'s fastest-growing counties. Divorce filed in Circuit or Chancery Court.',
    population: 247726,
  },
  {
    name: 'Wilson',
    court: 'Circuit & Chancery',
    district: '15th',
    city: 'Lebanon',
    courthouse: 'Wilson County Courthouse, 228 E. Main Street, Lebanon, TN 37087',
    phone: '615-444-1341',
    website: 'https://www.wilsoncountytn.gov',
    notes: 'Lebanon/Wilson County: divorce filed in Circuit or Chancery Court.',
    population: 153994,
  },
  {
    name: 'Anderson',
    court: 'Circuit & Chancery',
    district: '7th',
    city: 'Clinton',
    courthouse: 'Anderson County Courthouse, 100 N. Main Street, Clinton, TN 37716',
    phone: '865-457-6235',
    website: 'https://www.andersontn.org',
    notes: 'Oak Ridge/Clinton area. Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Bedford',
    court: 'Circuit & Chancery',
    district: '17th',
    city: 'Shelbyville',
    courthouse: 'Bedford County Courthouse, 1 Public Square, Shelbyville, TN 37160',
    phone: '931-684-1921',
    website: 'https://www.bedfordcountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Blount',
    court: 'Circuit & Chancery',
    district: '5th',
    city: 'Maryville',
    courthouse: 'Blount County Courthouse, 345 Court Street, Maryville, TN 37804',
    phone: '865-273-5400',
    website: 'https://www.blounttn.org',
    notes: 'Maryville/Alcoa area. Divorce cases heard in Circuit or Chancery Court.',
    population: 135280,
  },
  {
    name: 'Bradley',
    court: 'Circuit & Chancery',
    district: '10th',
    city: 'Cleveland',
    courthouse: 'Bradley County Courthouse, 155 Broad Street NW, Cleveland, TN 37311',
    phone: '423-728-7185',
    website: 'https://www.bradleycountytn.gov',
    notes: 'Cleveland area. Divorce cases heard in Circuit or Chancery Court.',
    population: 108620,
  },
  {
    name: 'Campbell',
    court: 'Circuit & Chancery',
    district: '8th',
    city: 'Jacksboro',
    courthouse: 'Campbell County Courthouse, 570 Main Street, Jacksboro, TN 37757',
    phone: '423-562-3496',
    website: 'https://www.campbellcountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Carter',
    court: 'Circuit & Chancery',
    district: '1st',
    city: 'Elizabethton',
    courthouse: 'Carter County Courthouse, 801 East Elk Avenue, Elizabethton, TN 37643',
    phone: '423-542-1814',
    website: 'https://www.cartercountytn.gov',
    notes: 'Elizabethton area. Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Cheatham',
    court: 'Circuit & Chancery',
    district: '23rd',
    city: 'Ashland City',
    courthouse: 'Cheatham County Courthouse, 100 Public Square, Ashland City, TN 37015',
    phone: '615-792-4316',
    website: 'https://www.cheathamcounty.net',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Chester',
    court: 'Circuit & Chancery',
    district: '26th',
    city: 'Henderson',
    courthouse: 'Chester County Courthouse, 133 E. Main Street, Henderson, TN 38340',
    phone: '731-989-2233',
    website: 'https://www.chestercountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Claiborne',
    court: 'Circuit & Chancery',
    district: '8th',
    city: 'Tazewell',
    courthouse: 'Claiborne County Courthouse, 415 Main Street, Tazewell, TN 37879',
    phone: '423-626-3284',
    website: 'https://www.claibornecountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Coffee',
    court: 'Circuit & Chancery',
    district: '14th',
    city: 'Manchester',
    courthouse: 'Coffee County Courthouse, 300 Hillsboro Blvd., Manchester, TN 37355',
    phone: '931-723-5106',
    website: 'https://www.coffeecountytn.gov',
    notes: 'Manchester area. Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Dickson',
    court: 'Circuit & Chancery',
    district: '23rd',
    city: 'Charlotte',
    courthouse: 'Dickson County Courthouse, 4 Court Square, Charlotte, TN 37036',
    phone: '615-789-7011',
    website: 'https://www.dicksoncountytn.gov',
    notes: 'Dickson area. Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Dyer',
    court: 'Circuit & Chancery',
    district: '29th',
    city: 'Dyersburg',
    courthouse: 'Dyer County Courthouse, 101 W. Court Square, Dyersburg, TN 38024',
    phone: '731-286-7814',
    website: 'https://www.dyercountytn.gov',
    notes: 'Dyersburg area. Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Fayette',
    court: 'Circuit & Chancery',
    district: '25th',
    city: 'Somerville',
    courthouse: 'Fayette County Courthouse, 16755 Highway 64, Somerville, TN 38068',
    phone: '901-465-5218',
    website: 'https://www.fayettecountytn.gov',
    notes: 'Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Franklin',
    court: 'Circuit & Chancery',
    district: '17th',
    city: 'Winchester',
    courthouse: 'Franklin County Courthouse, 1 S. Jefferson Street, Winchester, TN 37398',
    phone: '931-967-2906',
    website: 'https://www.franklincountytn.gov',
    notes: 'Winchester area. Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Gibson',
    court: 'Circuit & Chancery',
    district: '28th',
    city: 'Trenton',
    courthouse: 'Gibson County Courthouse, 1 Court Square, Trenton, TN 38382',
    phone: '731-855-7617',
    website: 'https://www.gibsoncountytn.gov',
    notes: 'Trenton area. Divorce cases heard in Circuit or Chancery Court.',
  },
  {
    name: 'Giles',
    court: 'Circuit & Chancery',
    district: '22nd',
    city: 'Pulaski',
    courthouse: 'Giles County Courthouse, 1 Public Square, Pulaski, TN 38478',
    phone: '931-363-1509',
    website: 'https://www.gilescountytn.gov',
    notes: 'Pulaski area. Divorce cases heard in Circuit or Chancery Court.',
  },
];

export const COUNTY_NAMES = COUNTIES.map(c => c.name);
